import { render, staticRenderFns } from "./block-settings-title.vue?vue&type=template&id=17aae731&scoped=true&"
import script from "./block-settings-title.vue?vue&type=script&lang=js&"
export * from "./block-settings-title.vue?vue&type=script&lang=js&"
import style0 from "./block-settings-title.vue?vue&type=style&index=0&id=17aae731&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aae731",
  null
  
)

export default component.exports